import React, { useRef } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import BootPay from "bootpay-js";
import NormalInput from '../common/input/NormalInput';
import NormalBtn from '../common/button/NormalBtn';
import { userInfoAction, userErrClearAction, userInfoUpdateAction, userNickInfoUpdateAction } from '../../modules/su/userInfoModule';
import NormalPopupOneBtn from '../common/popup/NormalPopupOneBtn';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import Modal from 'react-modal';
import { setNickAction } from '../../modules/su/userModule';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MySettingMemberTableBlock = styled.table`

    border-top: 2px solid #111;
    border-bottom: 0px solid #ccc;
    
    th {
        padding: 13px 5px 14px;
        font-size: 14px;
        text-align: center;
    }

    td {
        line-height: 1.5;
        position: relative;
        padding: 20px;
        border-top: 1px solid #ccc;
        vertical-align: middle;
        font-size: 15px;
        ${isMobileOnly?`
        padding: 20px 2vw;   
        `:`
        padding: 20px;
        `};
      }

      td.border_bottom {
        border-bottom: 1px solid #ccc;
      }

      td.border_right {
        border-right: 1px solid #ccc;
      }

      td.border_black {
        border-bottom: 1px solid #111;
      }

      td.border_none {
        border-top: none;
      }

      td.border_t-none {
        border-top: none;
      }

      td.padding_none {
        padding: 6px 0;
      }

      td.thumb_none {
        padding-left: 120px;
      }

      b {
        font-weight: 700;
      }

      .mint {
        background-color: rgba(0, 217, 184, 0.1);
      }

      .gray {
        background-color: #f4f4f4;
      }

      .input-box .text-input:disabled {
        color: #999;
        background-color: #e7e7e7;
      }
`;


const MySettingMemberTable = () => {

  const dispatch = useDispatch();
  const [confirm, setConfirm] = useState(false);
  const [nick, setNick] = useState(null);
  const [nickErr, setNickErr] = useState(false);
  const [nickErrTxt, setNickErrTxt] = useState("! 닉네임은 4자~20자 이내의 한글, 영문, 숫자로만 입력해주세요.");
  const [openModal, setOpenModal] = useState(false);
  //const [popupTxt, setPopupTxt] = useState("정상적으로 정보가 업데이트되었습니다.");
  const [msg, setMsg] = useState("");
  const [msg2, setMsg2] = useState("");
  const inputRef = useRef(null);

  // Redux Store에서 저장된 값을 가져옴
  const { code, nickname, sex, birth, mobile, name, errmsg, action, loading, nick_date, id } = useSelector(
    ({ userInfoReducer, loadingReducer, userReducer }) => ({
      code: userInfoReducer.code,
      nickname: userInfoReducer.nickname,
      sex: userInfoReducer.sex,
      birth: userInfoReducer.birth,
      mobile: userInfoReducer.mobile,
      name: userInfoReducer.name,
      loading: loadingReducer['userinfo/INFO'],
      action: userInfoReducer.action,
      errmsg: userInfoReducer.err,
      nick_date: userInfoReducer.nick_date,
      id: userReducer.id,
    })
  );

  useEffect(() => {
    // 업데이트 완료 시 팝업 표시
    if (code === 200 && action === 'userinfo/UPDATE_INFO_SUCCESS') {
      setOpenModal(true);
      setMsg("정상적으로 정보가 업데이트되었습니다.");
      setMsg2("");
      // user 정보 변경
      dispatch(setNickAction(nick));
    }
    else if (code === 200 && action === 'userinfo/UPDATE_NICK_INFO_SUCCESS') {
      setOpenModal(true);
      setMsg("정상적으로 정보가 업데이트되었습니다.");
      setMsg2("");
      // user 정보 변경
      dispatch(setNickAction(nick));
    }  else {
      dispatch(userInfoAction());
    }
  }, [code, action])

  useEffect(() => {
    if (errmsg !== null) {
      setNickErr(true);
      setNickErrTxt(errmsg);
      dispatch(userErrClearAction());
    }
  }, [errmsg])

  useEffect(() => {

    // console.log("nickname 변경 !!!")
    if(nickname != null){
      setNick(nickname);
    }

  }, [nickname, mobile,]);


  const handleConfirm = () => {

/*     if (validateNickName(nick) === false) {
      setNickErr(true);
      return;
    } */

    if (confirm === false) {

      let d = new Date();
      // 본인 인증 처리 시작
      // console.log(" 본인 인증 처리 시작 ---------> ")
      BootPay.request({
        price: 0, // 0으로 해야 한다.
        application_id: process.env.REACT_APP_BOOTPAY_ID,
        name: process.env.REACT_APP_BOOTPAY_NAME, //결제창에서 보여질 이름
        pg: 'danal',
        method: 'auth', // 빌링키를 받기 위한 결제 수단
        show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
        order_id: 'ODGAGU' + d.getTime(),
        params: {},
        extra: {
          age_limit: '14'
        }
      }).error(function (data) {
        // 본인인증 진행시 에러가 발생하면 수행됩니다.
        // console.log(" error : " + JSON.stringify(data));
      }).cancel(function (data) {
        // 본인인증이 취소되면 수행됩니다.
        // console.log("취소 : " + JSON.stringify(data));
      }).done(function (data) {

        // 정보 변경
        if (nick === null) {
          dispatch(userInfoUpdateAction(data.receipt_id));
        } else {
          dispatch(userInfoUpdateAction(data.receipt_id));
        }

        setConfirm(false);
      });
    }
  }


  const handleNickChange = () => {

    if (validateNickName(nick) === false) {
      setNickErr(true);
      setNickErrTxt("! 닉네임은 4자~20자 이내의 한글, 영문, 숫자로만 입력해주세요.");
      return;
    }

    if(nick !== null && nick.length > 1 && id.indexOf(nick) >= 0 ){
      setNickErr(true);
      setNickErrTxt("! 닉네임은 ID의 이메일과 동일한 문자열을 사용할 수 없습니다.");
      return;
    }

    if(checkDisableNick()){
      setOpenModal(true);
      setMsg("1년 이내 변경된 닉네임입니다.");
      setMsg2("");
      return;
    }

    setOpenModal(true);
    setMsg("변경 가능한 닉네임입니다.");
    setMsg2("변경 시 추가 변경은 1년 후 가능합니다.");

  }

  const checkDisableNick = () => {

    if(nick_date === null || nick_date === undefined){
      return false;
    }

    let date = new Date();
    let date1 = new Date(nick_date)

    let diffDay = (date.getTime()-date1.getTime())/(1000*60*60*24);

    //console.log("diffDay = " + diffDay);
    //console.log("nick_date = " + nick_date);

    if(diffDay > 365){
      return false;
    }

    return true;
  }

  const handleNickInput = (e) => {
    setNick(e.target.value);
    if(e.target.value !== null && e.target.value.length > 3 && id.indexOf(e.target.value) >= 0 ){
      setNickErr(true);
      setNickErrTxt("! 닉네임은 ID의 이메일과 동일한 문자열을 사용할 수 없습니다.");
      return;
    }

    if(!validateNickName(e.target.value)){
      setNickErr(true);
      setNickErrTxt("! 닉네임은 4자~20자 이내의 한글, 영문, 숫자로만 입력해주세요.");
      return;
    }

    setNickErr(false);
  }

  const validateNickName = (value) => {
    if (value === null) return false;

    if (value.length > 3 && value.length < 21) {
      // 공백 체크
      if (value.search(/\s/) > -1) return false;

      // 특수문자체크
      var special_pattern = /[~!@#$%^&*()_+|<>?:{}]/;
      return !special_pattern.test(value);
    }

    return false;
  }

  /**
   * 팝업 닫기 버튼 클릭 처리
   */
  const handleOneBtnPopupClick = () => {
    setOpenModal(false);
    dispatch(userInfoAction());
  }

  const handleModalBtn1Click = () => {
    setOpenModal(false);
    // 정보 변경
    if (nick === null) {
      dispatch(userNickInfoUpdateAction(nickname));
    } else {
      dispatch(userNickInfoUpdateAction(nick));
    }
  }

  const handleModalBtn2Click = () => {
      setOpenModal(false);
      if(inputRef.current){
        inputRef.current.value = nickname;
    }
  }

  return (
    <div>
      {isMobileOnly ?
        <MySettingMemberTableBlock style = {{width: '100%'}}>
        <colgroup>
          <col width="30%" />
          <col width="30%" />
          <col width="10%" />
          <col width="30%" />
        </colgroup>
        <tbody>
          <tr>
            <td className="gray">닉네임</td>
            <td colSpan="2">
              <b><span>
                <NormalInput
                  /* width="450px" */
                  maxLength='20'
                  placeholder={nickname}
                  defaultValue={nickname}
                  fontSize='12px'
                  errFontSize='10px'
                  errHeight='90px'
                  onChange={handleNickInput}
                  dispError={nickErr}
                  errText={nickErrTxt}
                  onFoucs={() => { setNickErr(!validateNickName(nickname)); }}
                  onBlur={() => { setNickErr(!validateNickName(nickname)); }}
                  disabled = {checkDisableNick()}
                  inputRef = {inputRef}
                />

              </span></b>
            </td>
            <td style={{paddingLeft:'0px'}}>
              <NormalBtn
                minWidth="90px"
                width="90px"
                lineHeight="40px"
                height="40px" borderRadius="30px"
                fontSize="16px" fontWeight="400"
                marginBottom="0px" marginTop="0px" float="none"
                text="변경"
                onClick={handleNickChange}  /></td>
          </tr>
          <tr>
            <td className="gray">성명</td>
            <td colSpan="3">
              <b><span>{name}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">연락처</td>
            <td colSpan="3">
              <b><span>{mobile}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">생년월일</td>
            <td colSpan="3">
              <b><span>{birth}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">성별</td>
            <td colSpan="3">
              <b><span>{sex}</span></b>
            </td>
          </tr>
          <tr>
            <td style={{ borderBottom: '0px ' }}></td>
            <td colSpan="4" style={{ borderBottom: '0px ' }}>
              <NormalBtn
                minWidth="55vw"
                width="55vw"
                lineHeight="40px"
                height="40px" borderRadius="30px"
                fontSize="16px" fontWeight="400"
                marginBottom="0px" marginTop="0px" float="none"
                text="본인인증으로 정보 수정하기"
                onClick={handleConfirm} />
            </td>
          </tr>
        </tbody>

        <Modal
          isOpen={openModal}
          onRequestClose={handleOneBtnPopupClick}
          style={customModalStyles}
          onAfterOpen={() => document.body.style.overflow = 'hidden'}
          onAfterClose={() => document.body.removeAttribute('style')}>
          {
                msg2 === "" ?
                    <NormalPopupOneBtn
                        text=""
                        text2={msg} text3=""
                        btn="확인" onClick={handleOneBtnPopupClick} /> :
                    <NormalPopup
                        text=""
                        text2={msg}
                        text3={msg2}
                        btn1="변경" btn2="취소"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
            }
        </Modal>

      </MySettingMemberTableBlock>
      :
        <MySettingMemberTableBlock>
        <colgroup>
          <col width="180px;" />
          <col width="440px;" />
          <col width="80px;" />
          <col width="265px;" />
        </colgroup>
        <tbody>
          <tr>
            <td className="gray">닉네임</td>
            <td colSpan="2">
              <b><span>
                <NormalInput
                  width="450px"
                  maxLength='20'
                  placeholder={nickname}
                  defaultValue={nickname}
                  fontSize='12px'
                  errFontSize='10px'
                  errHeight='90px'
                  onChange={handleNickInput}
                  dispError={nickErr}
                  errText={nickErrTxt}
                  onFoucs={() => { setNickErr(!validateNickName(nickname)); }}
                  onBlur={() => { setNickErr(!validateNickName(nickname)); }}
                  disabled = {checkDisableNick()}
                  inputRef = {inputRef}
                />

              </span></b>
            </td>
            <td style={{paddingLeft:'0px'}}>
              <NormalBtn
                minWidth="90px"
                width="90px"
                lineHeight="40px"
                height="40px" borderRadius="30px"
                fontSize="16px" fontWeight="400"
                marginBottom="0px" marginTop="0px" float="none"
                text="변경"
                onClick={handleNickChange}  /></td>
          </tr>
          <tr>
            <td className="gray">성명</td>
            <td colSpan="3">
              <b><span>{name}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">연락처</td>
            <td colSpan="3">
              <b><span>{mobile}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">생년월일</td>
            <td colSpan="3">
              <b><span>{birth}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">성별</td>
            <td colSpan="3">
              <b><span>{sex}</span></b>
            </td>
          </tr>
          <tr>
            <td style={{ borderBottom: '0px ' }}></td>
            <td colSpan="3" style={{ borderBottom: '0px ' }}>
              <NormalBtn
                minWidth="254.52px"
                width="254.52px"
                lineHeight="40px"
                height="40px" borderRadius="30px"
                fontSize="16px" fontWeight="400"
                marginBottom="0px" marginTop="0px" float="none"
                text="본인인증으로 정보 수정하기"
                onClick={handleConfirm} />
            </td>
          </tr>
        </tbody>

        <Modal
          isOpen={openModal}
          onRequestClose={handleOneBtnPopupClick}
          style={customModalStyles}
          onAfterOpen={() => document.body.style.overflow = 'hidden'}
          onAfterClose={() => document.body.removeAttribute('style')}>
          {
                msg2 === "" ?
                    <NormalPopupOneBtn
                        text=""
                        text2={msg} text3=""
                        btn="확인" onClick={handleOneBtnPopupClick} /> :
                    <NormalPopup
                        text=""
                        text2={msg}
                        text3={msg2}
                        btn1="변경" btn2="취소"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
            }
        </Modal>

      </MySettingMemberTableBlock>
      }

    </div>
  );
};

export default MySettingMemberTable;
